import { render, staticRenderFns } from "./SmartButton.vue?vue&type=template&id=4994e6f4&"
import script from "./SmartButton.vue?vue&type=script&lang=js&"
export * from "./SmartButton.vue?vue&type=script&lang=js&"
import style0 from "./SmartButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports